import { GroupComplianceMode } from '../../shared/model/group-compliance-mode';
import { GroupTypeMicrodelivery } from '../model/group-type-microdelivery';
import {
  ApiMetadataValidatorSlice,
  AtcSlice,
  CentralPolicyResultsSlice,
  CentralPolicyUsageSlice,
  CodeCoverageInfoSlice,
  ComplianceCertificatesSlice,
  ConfigurationSlice,
  CustomPolicyResultsSlice,
  CustomPolicyUsageSlice,
  DeliveriesSlice,
  DocumentsSlice,
  EnvironmentSlice,
  Fc2Slice,
  FosstarsSlice,
  LogAnalysisSlice,
  MalwarescanSlice,
  MicrodeliveriesSlice,
  PipelineRunSlice,
  PipelineSlice,
  ProcessingStatusSlice,
  RoutingSlice,
  SonarQubeCoverageSlice,
  TestRegressionSlice,
} from './app-state';

export const initialFosstarsSlice: FosstarsSlice = {
  aggregationSummary: undefined,
  aggregationDetails: null,
  pipelineRunsDetails: {},
  pipelineRunsSummary: {},
};

export const initialCentralPolicyResultsSlice: CentralPolicyResultsSlice = {
  pipelineRunsDetails: {},
  pipelineRunsSummary: {},
  groupSummary: undefined,
  groupDetails: null,
};

export const initialCustomPolicyResultsSlice: CustomPolicyResultsSlice = {
  pipelineRunsDetails: {},
  pipelineRunsSummary: {},
  groupSummary: undefined,
  groupDetails: null,
};

export const initialFc2Slice: Fc2Slice = {
  deliveryRequirements: [],
  deliveryTestcases: [],
  groupComplianceMode: GroupComplianceMode.LATEST,
  pipelineRunRequirements: {},
  pipelineRunRequirementsTestcases: {},
};

export const initialAtcSlice: AtcSlice = {
  aggregationSummary: undefined,
  aggregationDetails: [],
  allPipelineRunAtcInformation: {},
};

export const initialSonarQubeCoverageSlice: SonarQubeCoverageSlice = {
  groupSummary: undefined,
  groupDetails: null,
  selectedPipelineRuns: {},
};

export const initialCodeCoverageInfoSlice: CodeCoverageInfoSlice = {
  aggregationSummary: undefined,
  aggregationDetails: null,
  selectedPipelineRuns: {},
};

export const initialMicrodeliveriesSlice: MicrodeliveriesSlice = {
  activeMicrodeliveries: new Map<number, GroupTypeMicrodelivery>(),
  displayedMicrodeliveries: new Map<number, GroupTypeMicrodelivery>(),
};

export const initialDeliveriesSlice: DeliveriesSlice = {
  selectedDelivery: undefined,
  siriusDelivery: undefined,
  deliveryFixVersions: undefined,
  groupComplianceMode: GroupComplianceMode.LATEST,
};

export const initialPipelineRunSlice: PipelineRunSlice = {
  pipelineRuns: {},
  selectedPipelineRun: {},
};

export const initialPipelineSlice: PipelineSlice = {
  pipelines: [],
  searchedPipelines: [],
  searchString: '',
};

export const initialConfigurationSlice: ConfigurationSlice = {
  configurations: {},
  jiraComponentMappingsForPipelines: [],
};

export const initialTestRegressionSlice: TestRegressionSlice = {
  pipelineRequirements: {},
  pipelineRunRegressionTests: {},
};

export const initialMalwarescanSlice: MalwarescanSlice = {
  groupSummary: undefined,
  groupDetails: null,
  pipelineRunDetails: {},
};

export const initialDocumentsSlice: DocumentsSlice = {
  pipelineRunsDetails: {},
};

export const initialComplianceCertificatesSlice: ComplianceCertificatesSlice = {
  pipelineRunsDetails: {},
};

export const initialProcessingStatusSlice: ProcessingStatusSlice = {
  pipelineRunProcessingStatus: {},
};

export const initialApiMetadataValidatorSlice: ApiMetadataValidatorSlice = {
  groupSummary: undefined,
  groupDetails: null,
  pipelineRunsSummary: {},
};

export const initialCentralPolicyUsageSlice: CentralPolicyUsageSlice = {
  groupPolicyKeySummary: null,
  groupSummary: undefined,
  groupDetails: null,
};

export const initialCustomPolicyUsageSlice: CustomPolicyUsageSlice = {
  groupPolicyKeySummary: null,
  groupSummary: undefined,
  groupDetails: null,
};

export const initialEnvironmentSlice: EnvironmentSlice = {
  deliveryProcessingStatus: null,
  gcpStorageBaseUrl: null,
  hyperspaceOnboarding: null,
  hyperspacePortal: null,
  matomoApplicationId: null,
  matomoUrl: null,
  matomoInit: null,
  parentId: null,
  production: null,
  stage: null,
  activationDate: null,
  baseUrl: null,
  deliveryGuid: null,
  deliveryName: null,
  isLocked: null,
  readOnly: null,
  jiraUiBaseUrl: null,
  jiraDataCenterUrl: null,
  isJiraCloud: null,
  jiraFieldMappings: null,
};

export const initialRoutingSlice: RoutingSlice = {
  pipelineReleaseViewRoute: {
    deliveryGuid: null,
    pipelineId: null,
    microdeliveryId: null,
    pipelineRunKey: null,
    pipelineRunId: null,
    expectedCentralPolicyKeys: null,
  },
};

export const initialLogAnalysisSlice: LogAnalysisSlice = {
  pipelineRunResults: {},
};
